import _find from "lodash/find";

export const statuses = [
    {
        id: "idle",
        name: "En attente",
        classes: "bg-gray-400/10 text-gray-400 ring-gray-400/20",
    },
    {
        id: "pending",
        name: "En cours",
        classes: "bg-yellow-400/10 text-yellow-500 ring-yellow-400/20",
    },
    {
        id: "success",
        name: "Publiée",
        classes: "text-green-400 bg-green-500/10 ring-green-500/20",
    },
    {
        id: "failed",
        name: "Échec",
        classes: "bg-red-400/10 text-red-400 ring-red-400/20",
    },
];

export const getStatus = (status) => {
    return _find(statuses, ["id", status]);
};
